import { db } from '../firebase-client';
import {
  collection,
  addDoc,
  setDoc,
  updateDoc,
  doc,
  query,
  getDocs,
  getDoc,
  deleteDoc,
  Firestore
} from 'firebase/firestore';

export const getDb = (): Firestore => {
  if (!db) {
    throw new Error('Firestore is not initialized. Make sure you are running on the client side.');
  }
  return db as Firestore;
};

export const getCollectionDoc = async (path: string, id: string) => {
  const db = getDb();
  const ref = doc(db, path, id);
  const docSnap = await getDoc(ref);

  return { ...docSnap.data(), id: docSnap.id };
};

/**
 *
 * @param collection returns data for specified collections
 */
export const getCollectionData = async (path: string) => {
  const db = getDb();
  const q = query(collection(db, path));
  const querySnapshot = await getDocs(q);
  const results = querySnapshot.docs.map((d) => ({ ...d.data(), id: d.id }));
  return results;
};

export const removeDoc = async (path: string, id: string) => {
  const db = getDb();
  const ref = doc(db, path, id);
  await deleteDoc(ref);
  return true;
};

/**
 *
 * @param collection
 * @param data
 */
export const writeCollectionDoc = async (path: string, data: any) => {
  const db = getDb();
  const docRef = await addDoc(collection(db, path), data);

  return docRef.id;
};

export const updateCollectionDoc = async (path: string, data: any, id: string) => {
  const db = getDb();
  await setDoc(doc(db, path, id), data, { merge: true });
  return true;
};
